import React,{useState,useEffect} from 'react';
import { Dialog,DialogTitle,DialogContent,DialogActions,FormControl,InputLabel,Select,MenuItem,Button,Chip,Box } from '@mui/material';
import apiService from '../services/apiService.ts';

const ROLE_OPTIONS=['USER','ADMIN','MANAGER','SUPER_ADMIN'];

interface Props{
  open:boolean;
  onClose:()=>void;
  user:any;
  onSaved:()=>void;
}

const UserRolesDialog:React.FC<Props>=({open,onClose,user,onSaved})=>{
  const [roles,setRoles]=useState<string[]>([]);
  useEffect(()=>{setRoles(user?.roles||[]);},[user]);

  const handleSave=async()=>{
    await apiService.updateUserRoles(user.id,roles);
    onSaved();
    onClose();
  };

  return(
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Edit Roles for {user?.email}</DialogTitle>
      <DialogContent>
        <FormControl fullWidth>
          <InputLabel id="roles-label">Roles</InputLabel>
          <Select
            labelId="roles-label"
            multiple value={roles}
            onChange={e=>setRoles(typeof e.target.value==='string'?e.target.value.split(','):e.target.value as string[])}
            renderValue={(selected)=>(
              <Box sx={{display:'flex',flexWrap:'wrap',gap:0.5}}>
                {(selected as string[]).map((v)=>(<Chip key={v} label={v}/>))}
              </Box>
            )}
          >
            {ROLE_OPTIONS.map(r=>(
              <MenuItem key={r} value={r}>{r}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSave}>Save</Button>
      </DialogActions>
    </Dialog>
  );
};
export default UserRolesDialog;